import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { makeEntryInChat } from "../slices/IeqGptSlice"
import { notificationFail } from "../slices/notificationSlice";
import { RootState } from "../store";
import { getUserEventHistory, storeUserEventHistory } from "./userEventHistoryThunk";
import { ChatSourceTypeData } from "../../components/ieqGpt/InternalExternal";

export const getTopics = createAsyncThunk('getTopics', async (_request: { user_id: string }, { dispatch, rejectWithValue }) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_IEQGPT_DOMAIN_URL}/get_topics?user_id=${_request?.user_id}`);
        return response?.data;
    } catch (err) {
        return rejectWithValue({
            topic: []
        });
    }
});
export const saveTopic = createAsyncThunk('add_topic', async (_request: { topic: string, user_id: string }, { dispatch, rejectWithValue }) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_IEQGPT_DOMAIN_URL}/add_topic?topic=${encodeURIComponent(_request?.topic)}&user_id=${_request?.user_id}`, _request);
        dispatch(getTopics({ user_id: _request?.user_id }));
        await dispatch(storeUserEventHistory({
            title: 'Add Topic',
            module: 'ieq-gpt',
            detail: JSON.stringify({ request: _request?.topic, })
        }));
    } catch (err: any) {
        await dispatch(storeUserEventHistory({
            title: 'Add Topic',
            module: 'ieq-gpt',
            detail: JSON.stringify({ request: _request?.topic, response: err?.message, })
        }));
        dispatch(notificationFail("Topic is not created please try again."));
        return rejectWithValue({
            topic: []
        });
    }
});
export const updateTopic = createAsyncThunk('update_topic', async (_request: { old_topic: string; new_topic: string, user_id: string }, { dispatch, rejectWithValue }) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_IEQGPT_DOMAIN_URL}/edit_topic?old_topic=${encodeURIComponent(_request?.old_topic)}&new_topic=${encodeURIComponent(_request?.new_topic)}&user_id=${_request?.user_id}`, _request);
        dispatch(getTopics({ user_id: _request?.user_id }));
        await dispatch(storeUserEventHistory({
            title: 'Update Topic',
            module: 'ieq-gpt',
            detail: JSON.stringify({ request: `${_request?.old_topic} -> ${_request?.new_topic}`, })
        }));
    } catch (err: any) {
        await dispatch(storeUserEventHistory({
            title: 'Update Topic',
            module: 'ieq-gpt',
            detail: JSON.stringify({ request: `${_request?.old_topic} -> ${err?.message}`, })
        }));
        dispatch(notificationFail("Topic is not updated please try again."));
        return rejectWithValue({
            topic: []
        });
    }
});
export const searchTopic = createAsyncThunk('search_topic', async (_request: { topic: string, user_id: string }, { dispatch, rejectWithValue }) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_IEQGPT_DOMAIN_URL}/search_topic?topic=${encodeURIComponent(_request?.topic)}&user_id=${_request?.user_id}`);

        return response?.data;
    } catch (err: any) {
        return rejectWithValue({
            articles: [],
            error: err?.message
        });
    }
});
export const askQuestions = createAsyncThunk('ask_questions', async (_request: { question: string, user_id: string, id: string, type?: string }, { dispatch, rejectWithValue, getState }) => {
    const type = _request?.type || (getState() as RootState)?.IeqGptSlice?.currentType?.value; // internal,external,IEQ
    const messageSource = ChatSourceTypeData?.find(source => source?.value === type)?.name
    try {
        const response = await axios.post(`${process.env.REACT_APP_IEQGPT_DOMAIN_URL}/${type === 'saas' ? 'chat_ext' : type}?query=${encodeURIComponent(_request?.question)}&user_id=${_request?.user_id}`);
        const data = {
            id: _request?.id,
            message: response?.data?.results?.status_code === 200 ? response?.data?.results?.response : "I'm sorry, but I can't assist with that request. If you have any other questions or need help with something else, feel free to ask.",
            source: response?.data?.results?.source || '',
            type: type,
        }
        // await dispatch(getUserEventHistory());
        return data;
    } catch (err: any) {
        console.log(err, 'chatError')
        return rejectWithValue({
            id: _request?.id,
            message: 'We are currently unable to process your request. Please try again later.',
            error: err?.message || "server error"
        });
    }
});
